<template>
    <div>
        <vs-popup class="holamundo"    title="Import Images" :active.sync="importimages">
      <p v-if="movie && movie.response">
        <ImagesImport :movie="movie" @updateData="updateImage"/>
      </p>
    </vs-popup>
          <vs-tabs v-if="movie && movie.response" v-model="tab">
      <vs-tab label="Movie Info" icon="info">
        <div class="con-tab-ejemplo p-2">
           <addMovie ref="validateDetails" v-if="movie && movie.length !=0"  :mData="movie" style="height:100vh" />
           <vs-button @click="save">save</vs-button>
        </div>
      </vs-tab>
      <vs-tab label="Poster & Cover" icon="image">
        <div class="con-tab-ejemplo m-5" >
           <vs-button color="warning" @click="importimages=true">Import Images</vs-button>
          <h2>Poster</h2>
          <Poster :movie="movie" v-if="init"  /><br>
          <hr><br>
          <h2>Cover</h2>
          <Cover :movie="movie" v-if="init"  /> <br>
          <hr><br>
          <h2>Banner</h2>
          <Banner :movie="movie" v-if="init"  /><br>
          <hr><br>
          <h2>Logo</h2>
          <Logo :movie="movie" v-if="init"  /><br>
           
        </div>
      </vs-tab>
      <vs-tab label="Videos" icon="high_quality" v-if="movie.response.kind==1">
        <div class="con-tab-ejemplo m-5">
         <Videos :movie="movie" />
           
        </div>
      </vs-tab>
      <vs-tab label="Options" icon="settings" v-if="movie.response.kind==1">
        <div class="con-tab-ejemplo m-5">
            <Options :movie="movie"   />
          <br>
          <br>
          <br>
        </div>
      </vs-tab>
      <vs-tab label="Seasons & Epiosdes" icon="list" v-if="movie.response.kind==2">
        <div class="con-tab-ejemplo m-5">
            <Seasons :movie="movie.response"/>
        </div>
      </vs-tab>

    </vs-tabs>

     
        
              
    </div>
</template>
<script>
    import addMovie from './add.vue'
    import Poster from './poster.vue'
    import Cover from './cover.vue'
    import Banner from './banner.vue'
    import Logo from './movieLogo.vue'
    import Videos from './Videos.vue'
    import Options from './options.vue'
    import Subtitles from './Subtitles.vue'
    import Seasons from './seasons.vue'
    import ImagesImport from './ImportImages.vue'

export default {
    components:{
        addMovie,Poster,Videos,Options,Subtitles,Cover,Seasons,Banner,Logo,ImagesImport
    },
     data() {
         return {
             movie:[],
             importimages:false,
             init:true,
             tab:0
         }
     },
     created() {
         this.$store.dispatch('genres/fetchGenres');
         this.$store.dispatch('languages/fetchLanguages')
         if(this.$route.params.id){
             this.fetchMovie()
         }
         if (this.$route.query && this.$route.query.tab && this.$route.query.tab=='seasons') {
              this.tab=2; 
         }
     },
     methods: {
         save(){
                this.$refs.validateDetails.validate().then(result => {
                        if (result) {
                            if (this.movie.status) {
                                resolve(true)
                                this.$refs.tabs.nextTab();
                            }
                        } else {
                            reject('not Validated')
                        }
                    })
         },
          fetchMovie() {
                this.axios.get(`${this.$apiUrl}/v2/movies/fetch/${this.$route.params.id}`).then(res => {
                        this.movie = res.data;
                    })
            },
          updateImage(){
            this.init=false;
              this.importimages=false;
              this.fetchMovie;
              setTimeout(() => {
                this.init=true;
              }, 100);
          }
     },
}
</script>
<style lang="css">
  .con-vs-dialog {
    z-index: 60000;
}
</style>